import { render, staticRenderFns } from "./Actionbar.vue?vue&type=template&id=1ed83180"
import script from "./Actionbar.vue?vue&type=script&lang=js"
export * from "./Actionbar.vue?vue&type=script&lang=js"
import style0 from "./Actionbar.vue?vue&type=style&index=0&id=1ed83180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
